export default __webpack_public_path__ + "static/media/snow-night.480e2f6b.jpg";